import styled from 'styled-components';

export const Title = styled.h2`
  font-size: 28px;
  font-weight: 600;
  margin: 57px 0 21px 0;
  &.phoneTitle {
    @media screen and (max-width: 1150px) {
      margin: 10px 0 21px 0;
    }

    @media screen and (max-width: 767px) {
      margin: 0 0 21px 0;
    }
  }
  @media screen and (min-width: 481px) and (max-width: 767px) {
    text-align: center;
  }
`;

export const Count = styled.div`
  font-size: 12px;
  position: relative;
  right: 0;
  width: 100%;
  text-align: right;
  margin-bottom: 5px;
`;

export const ProductsContainer = styled.div`
  margin: 0 auto;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 22px;

  @media screen and (max-width: 1280px) {
    grid-template-columns: 1fr 1fr 1fr;
    gap: 24px;
  }

  @media screen and (max-width: 1024px) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;
